import React from "react";
import "./ProjectsSection.css";

import woodwork from "../../imgs/projects/01.jpg";
import flooring from "../../imgs/projects/02.jpg";
import kitchen from "../../imgs/projects/03.jpg";
import deck from "../../imgs/projects/04.jpg";

const projects = [
  { title: "Custom Woodwork", desc: "Built-in furniture and carpentry projects", img: woodwork },
  { title: "Tile Flooring", desc: "Professional tile installation and design", img: flooring },
  { title: "Kitchen Renovation", desc: "Complete kitchen remodel and upgrades", img: kitchen },
  { title: "Outdoor Deck", desc: "Deck construction and outdoor living spaces", img: deck }
];

export default function ProjectsSection() {
  return (
    <section id="projects" className="projects">
      <div className="inner3">
        <div className="eyebrow3">What I’ve Been Working On</div>
        <h2 className="section-title3">Projects I’m Proud Of</h2>
        <p className="section-subtitle3">
          Here’s a look at some of my recent work — from small fixes to bigger updates. If you’ve got a project in mind, I’d be happy to help bring it to life!
        </p>

        <div className="grid3">
          {projects.map((p, i) => (
            <div key={i} className="card3">
              <img src={p.img} alt={p.title} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}